import { useGetCLItem } from 'api/useAPIContextualizedLearning'
import { useGetTopicDetail } from 'api/useAPITopics'
import clsx from 'clsx'
import Head from 'next/head'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'

import { GATrackEvent } from 'utils/googleAnalytics'
import { shouldHideNav } from 'utils/helper'

import CLRenderer from 'components/CLRenderer'
import TopicHeader from 'components/Topic/TopicHeader'

const TopicReference = ({
  onPageLoaded,
}: {
  onPageLoaded?: (topicName?: string) => void
}) => {
  const { query } = useRouter()
  const { data } = useGetTopicDetail(query.topik as string)
  const topicData = data?.data

  const clItem = useGetCLItem(topicData?.contextualizedPageId).data?.data

  useEffect(() => {
    if (!!topicData?.name) {
      GATrackEvent({
        eventName: 'contextualized_learning',
        eventParams: {
          event_trigger: 'open_reference_tab',
          action_type: 'view_reference_tab',
          meta: JSON.stringify({
            topic_id: query.topik,
          }),
        },
        sendDefaultParams: true,
      })
      onPageLoaded?.(topicData?.name)
    }
  }, [onPageLoaded, query.topik, topicData?.name])

  const RenderTopicReference = () => (
    <CLRenderer
      clItem={clItem as any}
      topicId={+query.topik!}
      topicName={topicData?.name as string}
      trackerWidgetData={{
        source: 'reference_tab',
        kbPageId: clItem?.id as string,
      }}
    />
  )

  return (
    <>
      <Head>
        <title>Sertifikasi Pendidik | Referensi Topik</title>
      </Head>

      <div
        className={clsx('relative bg-gray-10 z-0', shouldHideNav() && 'pt-1')}
        style={{
          minHeight: shouldHideNav() ? '100vh' : 'calc(100vh - 3.5rem)',
        }}
      >
        {!shouldHideNav() && (
          <div className="sticky top-[54px] z-30">
            <TopicHeader
              title={topicData?.name || ''}
              shouldShowTab={Boolean(topicData?.contextualizedPageId)}
            />
          </div>
        )}

        <RenderTopicReference />
      </div>
    </>
  )
}

export default TopicReference
